import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';
import '../styles/Footer.css';

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="footer-container">
        <div className="footer-top">
          <div className="footer-column footer-info">
            <div className="footer-logo">
              <img
                src="/assets/images/beaver_logo1.png"
                alt="Beaver Tours Logo"
                className="footer-logo-image"
              />
              <span className="footer-logo-text">Beaver Tours</span>
            </div>
            <p className="footer-tagline">
              Explore the Journey, Live the Freedom!
            </p>
            <div className="footer-social-links">
              <a
                href="https://www.instagram.com/beavertours/"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social-link"
                aria-label="Follow Beaver Tours on Instagram"
              >
                <img
                  src="/assets/images/insta.png"
                  alt="Instagram Logo"
                  className="footer-social-icon"
                />
              </a>
              <a
                href="https://wa.me/919894150416"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social-link"
                aria-label="Chat with Beaver Tours on WhatsApp"
              >
                <img
                  src="/assets/images/whatsapp.png"
                  alt="WhatsApp Logo"
                  className="footer-social-icon1"
                />
              </a>
              <a
                href="https://www.protrack365.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social-link"
                aria-label="Track Your Vehicles"
              >
                <button className="track-vehicles-button">
                  Track Your Vehicles
                </button>
              </a>
            </div>
            <div className="footer-logo1">
              <img
                src="/assets/images/Danvi_Web_Logo.png"
                alt="Beaver Tours Logo"
                className="footer-logo-image1"
              />
              <span className="footer-logo-text1">Danvi Foods</span>
            </div>
            <p className="footer-tagline1">
              Explore and Buy 100% Natural Food Products - Visit Our Partner Website Today! <br/> <a href='https://danvifoods.in/'>danvifoods.in </a>
            </p>
          </div>

          <div className="footer-column footer-links">
            <h3 className="footer-heading">Quick Links</h3>
            <ul className="footer-nav">
              <li><a href="/" className="footer-link">Home</a></li>
              <li><a href="/about-us" className="footer-link">About Us</a></li>
              <li><a href="/blogs" className="footer-link">Blogs</a></li>
              <li><a href="/contact" className="footer-link">Contact</a></li>
            </ul>
          </div>

          <div className="footer-column footer-contact">
            <h3 className="footer-heading">Contact Us</h3>
            <ul className="contact-info">
              <li className="contact-item">
                <MapPin size={16} />
                <span>
                  4-A, Poosaripalayam, Balaji Nagar, Coimbatore<br />
                  , Tamil Nadu 641006
                </span>
              </li>
              <li className="contact-item">
                <Phone size={16} />
                <a href="tel:+919894150416">+919894150416</a>
              </li>
              <li className="contact-item">
                <Mail size={16} />
                <a href="mailto:info@beaverbikes.com">beavertours786@gmail.com</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="copyright">
            © {new Date().getFullYear()} Beaver Tours. All rights reserved.
          </div>
          <div className="copyright">
            Developed By WebNd Digii
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;